<template>
  <div plus>
    <div plus-inner>
      <div plus-padding>
        <button type="button" @click="plusBtn">
          <Icon name="plus"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/views/components/Icon';
export default {
  name: 'Plus',
  components: { Icon },
  methods: {
    plusBtn() {
      this.$emit('clicked');
    }
  }
};
</script>

<style lang="less">
@import "~@/less/proj";
[plus] { .p(0,20); .mt(40);
  [plus-inner] { .rel;
    [plus-padding] { .wh(40); .mh-c;
      button { .ib; .-a(#878d96); .p(10, 11);
        &:hover {
          transition: background-color 1s;
        }
        .no-touch &:hover {
          background-color: #878d96;
        }
      }
    }
  }
}
@media (min-width: @screen-md-min) {
  [plus] { .p(0, 21); }
}

@media (min-width: @screen-lg-min) {
  [plus] { .p(0, 40); .mt(60); }
}

@media (min-width: @screen-xl-min) {
  [plus] { .p(0, 160); .mt(80); }
}
</style>
